import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useQuickSearch } from '@/components/quick-search/quick-search-provider';
import { quickSearchShortcutHint } from '@/lib/platform-shortcut';
import { cn } from '@/lib/utils';

type QuickSearchTriggerProps = {
  className?: string;
};

export function QuickSearchTrigger({ className }: QuickSearchTriggerProps) {
  const { setOpen } = useQuickSearch();
  const shortcut = quickSearchShortcutHint();

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('hidden h-8 gap-2 px-2 text-muted-foreground sm:inline-flex', className)}
      onClick={() => setOpen(true)}
      aria-label={`Open quick search (${shortcut})`}
    >
      <Search className="h-4 w-4 shrink-0" />
      <span className="hidden md:inline">Search</span>
      <kbd className="pointer-events-none hidden rounded border bg-muted px-1.5 py-0.5 font-mono text-[10px] font-medium text-muted-foreground lg:inline-block">
        {shortcut}
      </kbd>
    </Button>
  );
}

export function QuickSearchTriggerIcon({ className }: QuickSearchTriggerProps) {
  const { setOpen } = useQuickSearch();
  const shortcut = quickSearchShortcutHint();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn('h-8 w-8 sm:hidden', className)}
      onClick={() => setOpen(true)}
      aria-label={`Open quick search (${shortcut})`}
    >
      <Search className="h-4 w-4" />
    </Button>
  );
}
